import React from 'react';
import { useNavigate } from 'react-router-dom';
import { allowGuest } from '../utils/session';
import { logEvent } from '../utils/experimentLog';

// 番号を選ばずに演習へ進もうとしたときの確認モーダル（Home の演習ボタン・演習URLへの直接アクセスで共用）。
// 「そのまま進める」でこのタブの間だけ番号なしの演習を許可し、to へ進む（または onProceed を呼ぶ）。
// onCancel を省くと「やめる」で Home へ戻る。
function GuestConfirmDialog({ to, onProceed, onCancel }) {
  const navigate = useNavigate();

  const proceed = () => {
    allowGuest();
    logEvent('guest_start', { to: to || window.location.pathname });
    if (typeof onProceed === 'function') onProceed();
    else navigate(to);
  };

  return (
    <div className="advance-dialog-backdrop">
      <div className="advance-dialog" role="alertdialog" aria-modal="true" aria-label="番号の確認">
        <p className="advance-dialog__title">番号が選ばれていません</p>
        <p className="advance-dialog__note">
          あなたの番号が指定されていませんが、そのまま演習を進めますか？
          番号を選ばずに進めると、途中でやめたときに続きから始められません。
        </p>
        <div className="row-center gap-3">
          <button type="button" className="btn-sheet btn-sheet--attention" onClick={proceed}>
            そのまま進める
          </button>
          <button type="button" className="btn-sheet" onClick={() => navigate('/login')}>
            番号を選ぶ
          </button>
          <button
            type="button"
            className="btn-sheet btn-sheet--quiet"
            onClick={() => (typeof onCancel === 'function' ? onCancel() : navigate('/'))}
          >
            やめる
          </button>
        </div>
      </div>
    </div>
  );
}

export default GuestConfirmDialog;
